<div class="p-text-right">
	<div *ngIf="activeShifts.length">
		<span>On Shift:</span>

		<span class="cursor-default" *ngFor="let shift of activeShifts; index as idx"
			  (click)="!hoverSupported && showOverlayPanel(shift.safeToolTip, $event)"
			  [pTooltip]="shift.toolTip" appendTo="body" [escape]="false" tooltipPosition="left">
			{{shift.user.firstName}} {{shift.user.lastName}} {{idx < activeShifts.length - 1 ? ',' : ''}}
		</span>
		<ng-container *ngIf="!hoverSupported">
			<p-overlayPanel #overlayPanel appendTo="body" [showCloseIcon]="true">
				<ng-template pTemplate>
					<div>
						<span class="p-text-left">{{overlayPanelText}}</span>
					</div>
				</ng-template>
			</p-overlayPanel>
		</ng-container>
	</div>

	<span *ngIf="!activeShifts.length">
		No Shift Operators
	</span>

	<div>
		<button pButton *ngIf="displayExtension && !signOffPending && !extensionPending"
			label="{{minutesLeft}} minute{{minutesLeft === 1 ? '' : 's'}} remaining"
			(click)="showExtensionConfirm()" class="p-button-link">
		</button>

		<button pButton *ngIf="!userShift && canWrite && !signOffPending && !extensionPending"
			label="Shift Sign In" (click)="signOnToShift()" class="p-button-link">
		</button>

		<button pButton *ngIf="userShift && canWrite && !signOffPending && !extensionPending"
			label="Shift Sign Out" (click)="exitShift()" class="p-button-link">
		</button>

		<span *ngIf="signOffPending" class="p-d-flex p-ai-center p-my-2">
			<span class="pi pi-spin pi-spinner p-mr-3"></span>
			Signing out of shift
		</span>
		
		<span *ngIf="extensionPending" class="p-d-flex p-ai-center p-my-2">
			<span class="pi pi-spin pi-spinner p-mr-3"></span>
			Updating Shift
		</span>
	</div>
</div>

<p-dialog [(visible)]="dialogVisible" [modal]="true" [draggable]="false" header="Shift Sign On">
    <shift-sign-on #signOnComponent (signOnCompleted)="timeoutSignOn()">
        <ng-template pTemplate="button" let-button="buttonTemplate">
            <!--Sign on-->
            <div *ngIf="!signOnComponent.ackNotes.length && !signOnComponent.signOnCompleted">
                <p-divider></p-divider>
                <div class="p-grid p-text-center">
                    <div class="p-col-6">
                        <button pButton class="p-button-secondary w-100" label="Cancel" (click)="dialogVisible = false"></button>
                    </div>
                    <div class="p-col-6">
                        <ng-container *ngTemplateOutlet="button"></ng-container>
                    </div>
                </div>
            </div>
        </ng-template>
    </shift-sign-on>
</p-dialog>

<p-confirmDialog #ed key="shiftExtendDialog"></p-confirmDialog>